import { Component, OnInit } from '@angular/core';
import { Global } from "../../classes/global";
import { Router } from '@angular/router'
import { NeedAuthorize } from "../../classes/needAuthorize";
import { UserService } from "../../services/user/user.service";
import { MerchantService } from "../../services/merchant/merchant.service";

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss']
})
export class SiteLayoutComponent implements OnInit {

  currentUrl: any;
  userData: any;
  hasGrantedMerchantGroup: boolean = false;

  constructor(
    private router: Router,
    public global: Global,
    private userService: UserService,
    private merchantService: MerchantService) {
    this.userData = userService.getLocalUserInfo();

    this.router.events.subscribe((event) => {
      var evenUrl = (event as any).url;
      if (evenUrl != undefined) {
        this.currentUrl = evenUrl;
      }
    });
  }

  ngOnInit(): void {
    this.merchantService.getGrantedMerchantGroups().subscribe(
      data => {
        this.hasGrantedMerchantGroup = Array.isArray(data) && data.length > 0;
      },
      () => {
        this.hasGrantedMerchantGroup = false;
      }
    );
  }

  canViewProductReport(): boolean {
    if (!this.userData) {
      return false;
    }

    return this.userData.isSuperAdmin
      || this.userData.isAdmin
      || this.userData.roles.indexOf('Team Leader') > -1
      || this.userData.roles.indexOf('Seller') > -1;
  }

  canViewPersonalDailyReport(): boolean {
    return true;
  }

  showReportMenu(): boolean {
    return this.canViewProductReport() || this.canViewPersonalDailyReport();
  }

  canViewAccounts(): boolean {
    if (!this.userData) {
      return false;
    }
    return this.userData.isSuperAdmin
      || this.userData.isAdmin
      || this.userData.roles.indexOf('Team Leader') > -1;
  }

  canViewMerchants(): boolean {
    if (!this.userData) {
      return false;
    }
    return this.hasGrantedMerchantGroup && (
      this.userData.isSuperAdmin
      || this.userData.isAdmin
      || this.userData.roles.indexOf('Team Leader') > -1
      || this.userData.isGrantedForMerchantActions > -1
    );
  }

  canViewMerchantGroup(): boolean {
    if (!this.userData) {
      return false;
    }
    return this.userData.isSuperAdmin
      || this.userData.isAdmin
      || this.userData.roles.indexOf('Team Leader') > -1;
  }

  showUserAndMerchantMenu(): boolean {
    return this.canViewAccounts() || this.canViewMerchants() || this.canViewMerchantGroup();
  }

  canViewTikTokAds(): boolean {
    if (!this.userData) {
      return false;
    }
    return this.userData.isSuperAdmin
      || this.userData.isAdmin
      || this.userData.roles.indexOf('Team Leader') > -1
      || this.userData.roles.indexOf('Seller') > -1
      || this.userData.roles.indexOf('Support') > -1;
  }

  toggleSidebar(event: Event) {
    event.preventDefault();
    document.body.classList.toggle('sb-sidenav-toggled');
  }

  logout() {
    this.userService.logout();
  }
}
